import L from "leaflet";
import { useCallback, useEffect, useRef } from "react";

import IconButton from "components/buttons/IconButton/IconButton";

import CheckIcon from "assets/icons/check.svg";
import CloseIcon from "assets/icons/close-small.svg";

import styles from "./map-confirm-controls.module.scss";

interface MapConfirmControlsInterface {
  onAccept?: () => void;
  onDecline?: () => void;
}

const MapConfirmControls = ({
  onAccept,
  onDecline
}: MapConfirmControlsInterface) => {
  const confirmControlsRef = useRef(null);

  useEffect(() => {
    if (confirmControlsRef.current) {
      L.DomEvent.disableClickPropagation(confirmControlsRef.current);
      L.DomEvent.disableScrollPropagation(confirmControlsRef.current);
    }
  }, []);

  const onAcceptClick = useCallback(() => {
    onAccept();
  }, [onAccept]);

  const onDeclineClick = useCallback(() => {
    onDecline();
  }, [onDecline]);

  return (
    <div className={styles["map-confirm-controls"]} ref={confirmControlsRef}>
      <IconButton
        icon={CheckIcon}
        alt="check-icon"
        className={styles["icon-button"]}
        onClick={onAcceptClick}
      />
      <IconButton
        icon={CloseIcon}
        alt="close-icon"
        className={styles["icon-button"]}
        onClick={onDeclineClick}
      />
    </div>
  );
};

export default MapConfirmControls;
